import * as PropTypes from "prop-types";

import { UPLink } from "@up/ui";

const CourseListingItem2 = function ({ data, theme }) {
  return (
    <UPLink
      className={`block w-full course-listing-link p-4 pb-3 ${theme} ${
        data.cta_classes ? data.cta_classes : ""
      } ${theme === "theme-blue-medium" ? "text-white" : "text-blue-medium"}`}
      field={data.cta_link}
    >
      {data.course_title && (
        <p
          className={`text-sm font-medium border-b pb-2 mb-3 ${
            theme === "theme-blue-medium"
              ? "border-b-[#003DA5]"
              : "border-b-white"
          }`}
        >
          {data.course_title}
        </p>
      )}
      {data.course_category && (
        <p className="flex items-center m-0 text-3xl font-serif italic">
          <span className="flex-grow">
            {data.course_category.replace("College Credit ", "")}
          </span>
          <svg
            className="block"
            width="12"
            height="22"
            viewBox="0 0 12 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L11 11L1 21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </p>
      )}
    </UPLink>
  );
};

CourseListingItem2.propTypes = {
  data: PropTypes.object.isRequired,
  theme: PropTypes.string,
};

export default CourseListingItem2;
